import { Field, ID, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'

@InputType()
export class RevokePurchaseOrderDocumentLinksArgs extends ActionArgs {
  @Field(() => ID)
  purchaseOrderId: string
}

// TResult is the number of links revoked
export interface IRevokePurchaseOrderDocumentLinks extends IAction<number, RevokePurchaseOrderDocumentLinksArgs> {}
